// A set of helpers that deal with URL and parameter manipulation
// ----------------------------------------------------------------------------

import $ from "jquery";

const UrlHelpers = {
	/*
	 * Convert the params of a URL to a javascript object for easier use.
	 *
	 * @param {string} [url] - optionally pass a URL to parse. if null, it will
	 *   use window.location.
	 * @return {Object} - an object with the params of the url
	 */
	getParams(url) {
		let parser;

		if (url) {
			parser = document.createElement("a");
			parser.href = url;
		} else {
			parser = window.location;
		}

		const params = parser.search.substring(1).split("&");
		const obj = {};

		params.forEach((param) => {
			if (!param) {
				return;
			}

			const split = param.split("=");
			obj[decodeURIComponent(split[0])] = decodeURIComponent(split[1]);
		});

		return obj;
	},

	/*
	 * Get the value for a param in the url. Returns null if undefined.
	 *
	 * @param {string} param - the parameter to query
	 * @param {string} [url] - the url to check, or null to use window.location
	 * @return {string|null} - the value of the requested parameter
	 */
	getParam(param, url) {
		const params = this.getParams(url);

		if (params[param]) {
			return params[param];
		} else {
			return null;
		}
	},

	/*
	 * Make a url out of an object.
	 *
	 * @param {string} base - the root of the url
	 * @param {Object} params - an object of params to convert to url-style
	 * @return {string} - the url
	 */
	makeUrl(base = "", params) {
		return `${base}?${$.param(params)}`;
	},
};

// bind to the window for legacy imports
window.UrlHelpers = UrlHelpers;

export default UrlHelpers;



// WEBPACK FOOTER //
// ./src/shared/util/UrlHelpers.js